/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtYWRkcmVzcy1pbnB1dC90eC1hZGRyZXNzLWlucHV0LmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9qZW5raW5zL3dvcmtzcGFjZS9wcm9kdWN0aW9uLWFyZ29zLWZyb250L2FyZ29zL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudC90eC1hZGRyZXNzLWlucHV0L3R4LWFkZHJlc3MtaW5wdXQuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/shared/component/tx-address-input/tx-address-input.component.css.shim.ngstyle.ts